"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("@chakra-ui/react");

var _react2 = _interopRequireDefault(require("react"));

var _Table = _interopRequireDefault(require("./Table"));

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["items"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var prepareData = function prepareData(items) {
  return items.map(function (e) {
    return {
      fileName: /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.HStack, {
          spacing: 5,
          children: [e.prefix, /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Text, {
            children: e.name
          })]
        })
      }),
      fileLastModifiedAt: e.modifiedAt,
      fileSize: e.fileSize || '-',
      isDropzone: e.isFolder
    };
  });
};

var columns = [{
  Header: 'Name',
  accessor: 'fileName',
  width: '78%'
}, {
  Header: 'Last modified',
  accessor: 'fileLastModifiedAt'
}, {
  Header: 'File size',
  accessor: 'fileSize',
  isNumeric: true,
  disableSortBy: true
}];
var initialState = {
  sortBy: [{
    id: 'fileLastModifiedAt',
    desc: true
  }]
};

var FileList = function FileList(_ref) {
  var items = _ref.items,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Table["default"], _objectSpread({
    columns: columns,
    records: prepareData(items),
    initialState: initialState
  }, props));
};

var _default = /*#__PURE__*/_react2["default"].memo(FileList);

exports["default"] = _default;